<template>
    <div class="lookupdetail">
        <div class="lookup">
            <form  ref="lookupform" @submit.prevent="lookup">
                <div class="vertFlexLeft">
                    <div class="lookupHeader">
                        <label class="titlelabel bottom10">{{lookupPromptText}}</label>
                        <linkbutton toplabel="Clear" @click="clearLookup()" class="clearlink"/>
                    </div>
                    
                    <div >
                        <div class="entryTextDiv">
                            <label class="entryLabel" for="locationselect">Location</label>
                        </div>
                        <select name="" id="locationselect" class='entrySelect' v-model="locationId" required>
                            <option v-for="loc in locationList_Inventory" :key="loc.id" :value="loc.id" >
                                {{loc.name}}
                            </option>
                        </select>
                    </div>
                    <formentrystacked inputid="lookupstring"  label="Name/Code" v-model="productString" minlength="3"  />
                    <div class="horizFlex ">
                        <input id="showinactivecheck" class="entryCheckbox" type="checkbox" v-model="showInactive" >
                        <label for="showinactivecheck" class="mediumtext">Show Inactive</label>
                    </div>
                    <div class="lookupHeader">
                        <updateproduct :locationId="locationId" @refresh="Refresh" :isAdd="trueParam" buttonclass="innerbutton" @refreshnew="RefreshNew"/>
                        <smallbutton @click="lookup()" toplabel="Go" buttonclass="button buttonprimary innerbutton"/>
                    </div>
                    
                </div>
            </form>
  
            <div v-if="pleaseWait">
                <label  class="pleasewaitlabel">{{pleaseWaitText}}</label>
            </div> 
            <div>
                <label class="responsemessage">{{responseMessage}}</label>
            </div>
                <div ref="lookupresultsdiv" class="resultsdiv" v-if="lookupresults.length>0" tabindex="0">
                <div v-for="result in lookupresults" :key="result.id" :value="result.id" >
                    <lookupresult :topLeft="buildResultName(result)"  :bottomLeft="toCurrency(result.price)"    @click="select(result)"
                        :selected="result.id==selectedResultID" :inactive="!result.isActive">
                    
                    </lookupresult>  
                </div>
            </div>
            <typeadmin v-if="showProductPrepAreas" typeName="Prep Area" :typeList="prepAreaList" @save="savePrepArea"/>
            <optiontypeadmin v-if="showProductOptions" typeName="Option" :typeList="productOptionList" @save="saveProductOption" @refresh="Refresh"/>

            <!-- STREAM C: Product Type Ecommerce Flags admin (collapsible) -->
            <div v-if="showEcomTypeAdmin" class="ecomAdminPanel">
                <div class="lookupHeader">
                    <label class="titlelabel bottom10">Product Type — Online</label>
                    <linkbutton :toplabel="typeOnlineExpanded ? 'Hide' : 'Show'" @click="toggleTypeOnline()" class="clearlink"/>
                </div>
                <div v-if="typeOnlineExpanded" class="ecomAdminScroll">
                    <div v-for="pt in productTypeEcomList" :key="pt.id" class="horizFlex ecomAdminRow">
                        <label class="mediumtext right10">{{pt.name}}</label>
                        <label class="smalltext right10">{{pt.showOnline ? 'Online' : 'Hidden'}}</label>
                        <updateproducttype :inProductType="pt" :locationId="locationId" @refresh="loadProductTypeEcom()"/>
                    </div>
                </div>
            </div>

            <!-- STREAM D: Product Line ShowOnline toggle (collapsible) -->
            <div v-if="showEcomLineAdmin" class="ecomAdminPanel">
                <div class="lookupHeader">
                    <label class="titlelabel bottom10">Product Line — Online</label>
                    <linkbutton :toplabel="lineOnlineExpanded ? 'Hide' : 'Show'" @click="toggleLineOnline()" class="clearlink"/>
                </div>
                <div v-if="lineOnlineExpanded" class="ecomAdminScroll">
                    <div v-for="pl in productLineEcomList" :key="pl.id" class="horizFlex ecomAdminRow">
                        <input :id="'lineonline'+pl.id" class="entryCheckbox" type="checkbox" v-model="pl.showOnline" @change="saveProductLineEcom(pl)">
                        <label :for="'lineonline'+pl.id" class="mediumtext">{{pl.name}}</label>
                    </div>
                </div>
            </div>

        </div>
  
        <div v-if="selectedResultID>0" class="pad10">
            <div class="bordered">
                <div class="horizFlexStretch">
                    <div class="horizFlex">
                        <label class="titlelabel bold right10">{{currentProduct.name}} </label>
                        <updateproduct :inProduct="currentProduct" :locationId="locationId" @refresh="Refresh"  />
                    </div>
                    <linkbutton toplabel="Refresh" @click="Refresh()" class="clearlink"/>
                </div>
                <div class="splitDiv ">
                    <!-- left col -->
                    <div class="leftjustified vertFlex padright">
                        
                        
                        <div class="dataitem" v-if="isVisible('Name')">
                            <p >Name:</p>
                            <p >{{currentProduct.name}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('Type')">
                            <p >Type:</p>
                            <p >{{currentProduct.typeName}}</p>
                        </div>
                        <div class="dataitem" v-if="isVisible('Line')">
                            <p >Line:</p>
                            <p >{{currentProduct.lineName}}</p>
                        </div>
                        
                        <div class="dataitem"  v-if="isVisible('Vendor')">
                            <p >Vendor:</p>
                            <p >{{currentProduct.vendorName}}</p>
                        </div>
                        <hr/>
                        <div class="dataitem"  v-if="isVisible('Cost')">
                            <p >Cost:</p>
                            <p >{{toCurrency(currentProduct.cost)}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('Price')">
                            <p >Price:</p>
                            <p >{{toCurrency(currentProduct.price)}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('IsRetail')">
                            <p >Retail:</p>
                            <p >{{currentProduct.isRetail}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('IsSale')">
                            <p >Sale Product:</p>
                            <p >{{currentProduct.isSale}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('ShowOnline')">
                            <p >Show Online:</p>
                            <p >{{currentProduct.showOnline}}</p>
                        </div>
                        <template v-if="showEcomOnline">
                            <div class="dataitem" v-if="currentProduct.nameOnline">
                                <p >Name Online:</p>
                                <p >{{currentProduct.nameOnline}}</p>
                            </div>
                            <div class="dataitem" v-if="currentProduct.confirmationMessage">
                                <p >Confirmation Msg:</p>
                                <p >{{currentProduct.confirmationMessage}}</p>
                            </div>
                            <div class="dataitem">
                                <p >Max Purchase:</p>
                                <p >{{currentProduct.maxPurchaseCount || '—'}}</p>
                            </div>
                            <div class="dataitem">
                                <p >Max / Day:</p>
                                <p >{{currentProduct.MaxPurchaseCountPerDay || '—'}}</p>
                            </div>
                            <div class="dataitem">
                                <p >Require Stock:</p>
                                <p >{{currentProduct.requireStockOnline}}</p>
                            </div>
                        </template>
                        <template v-if="showEcomShipping">
                            <div class="dataitem" v-if="currentProduct.shippingAmount != null">
                                <p >Ship Amount:</p>
                                <p >${{currentProduct.shippingAmount}}</p>
                            </div>
                            <div class="dataitem" v-if="currentProduct.shippingProductCode">
                                <p >Ship Code:</p>
                                <p >{{currentProduct.shippingProductCode}}</p>
                            </div>
                        </template>
                        <div class="dataitem"  v-if="isVisible('IsTaxable')">
                            <p >Taxable:</p>
                            <p >{{currentProduct.isTaxable}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('IsFireable')">
                            <p >Is Fireable:</p>
                            <p >{{currentProduct.isFireable}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('IsFinancialAid')">
                            <p >FA Eligible:</p>
                            <p >{{currentProduct.isFinancialAidEligible}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('IsFinancialAid') && currentProduct.isFinancialAidEligible">
                            <p >{{FACodeText}} - FA</p>
                            <p >{{glCode_Anthology_FA}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('IsFinancialAid')">
                            <p >{{FACodeText}} - Cash</p>
                            <p >{{glCode_Anthology_Cash}}</p>
                        </div>
                        <hr/>
                        <div class="dataitem"  v-if="isVisible('Code')">
                            <p >Code:</p>
                            <p >{{currentProduct.code}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('UPC')">
                            <p >UPC: </p>
                            <p >{{currentProduct.upc}}</p>
                        </div>
                        
                        <hr/>
                        <div class="dataitem"  v-if="isVisible('PreferredOrder')">
                            <p >Prefer. Ord.:</p>
                            <p >{{currentProduct.preferredOrderQuantity}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('Target')">
                            <p >Reorder Alert Qty:</p>
                            <p >{{currentProduct.targetQuantity}}</p>
                        </div>
                        <div class="dataitem"  v-if="isVisible('OnHand')">
                            <p >On Hand:</p>
                            <p >{{currentProduct.onHandQuantity}}</p>
                        </div>
                        
                    </div>

                    <!-- right col -->
                    <div class="leftjustified vertFlex ">
                        
                        <div>
                            <label class="  right10">Locations:</label>
                            <div v-for="pl in currentProduct.productLocationList" :key="pl.id" :value="pl.id" >
                                <div class="locationdiv">
                                    <img alt="check image" src="@/assets/check.png" class="locationcheck" v-if="pl.isActive" />
                                    <p v-if="!pl.isActive"></p>
                                    <p >{{pl.locationName}}</p>
                                </div>
                                
                            </div>
                        </div>

                        <hr/>

                        <!-- OPTIONS -->
                        <div v-if="showProductOptions" class="dataitem">
                            <label class="  right10">Options:</label>
                            <label >{{currentProduct.productOptionsString}}</label>
                            <updateoptions ref="updateoptions" :product="currentProduct" @refresh="Refresh"/>
                        </div>

                        <hr/>

                        <!-- PREP AREAS -->
                        <div v-if="showProductPrepAreas" class="dataitem">
                            <label class="  right10">Prep Area(s):</label>
                            <label >{{currentProduct.prepAreaString}}</label>
                            <updateprepareas ref="updateprepareas" :product="currentProduct" @refresh="Refresh"/>
                        </div>

                        <hr v-if="showProductReports"/>

                        <div class="horizFlex" v-if="showProductReports">
                            <div class="vertFlex">
                                <!-- print barcodes-->
                                <barcodes :showButton="trueParam"  class="innerbutton" :locationId="this.locationId" :productId="currentProduct.id" 
                                    :onHand="currentProduct.onHandQuantity" @barcodes="printbarcodes"/> 
                                <a :href="barcodesURL" target="_blank" class="reportLink" v-if="barcodesURL!=null">
                                    Download Barcodes
                                    <!-- <smallbutton toplabel="Download Barcodes" ></smallbutton> -->
                                </a>
                            </div>
                            
                            <div class="vertFlex">
                                <!-- print price labels-->
                                <pricelabels :showButton="trueParam"  class="innerbutton" :locationId="this.locationId" :productId="currentProduct.id" 
                                    :onHand="currentProduct.onHandQuantity" @pricelabels="printpricelabels"/> 
                                <a :href="pricelabelURL" target="_blank" class="reportLink" v-if="pricelabelURL!=null">
                                    Download Price Labels
                                    <!-- <smallbutton toplabel="Download Barcodes" ></smallbutton> -->
                                </a>
                            </div>
                        </div>
                        
                        
                        
                            
                            <!-- Ecommerce multi-image manager (Cloudflare Images via X-API-Key) -->
                            <div class="ecomImageAdmin" v-if="showImageAdmin">
                                <hr/>
                                <label class="subtitleBold">Product Images</label>
                                <div class="horizFlex" style="flex-wrap:wrap;">
                                    <div v-for="img in ecomImages" :key="img.productImageId" class="ecomImageCard">
                                        <img :src="ecomImageUrl(img)" class="ecomImageThumb" alt="product image"/>
                                        <div class="ecomImagePrimary" v-if="img.isPrimary">★ Primary</div>
                                        <div class="vertFlex">
                                            <smallbutton v-if="!img.isPrimary" toplabel="Set as Primary" buttonclass="button buttonsave imgcardbtn" @Click="setEcomPrimary(img.productImageId)"/>
                                            <smallbutton toplabel="Delete" buttonclass="button buttoncancel imgcardbtn" @Click="deleteEcomImage(img.productImageId)"/>
                                        </div>
                                    </div>
                                    <div v-if="ecomImages.length==0" class="messagetext">No images yet.</div>
                                </div>
                                <div class="horizFlex" style="margin-top:10px;align-items:center;">
                                    <input type="file" accept="image/*" ref="ecomImageFile" @change="onEcomFilePicked"/>
                                    <smallbutton class="left10" toplabel="Upload" @Click="uploadEcomImage"/>
                                </div>
                                <label class="messagetext">{{ ecomImageMsg }}</label>
                            </div>

                            <!-- <label>{{resetMsg}}</label> -->



                    </div>
                </div>
                
            </div>

        </div>
        
    </div>
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import datamethods from '../../services/datamethods.js'
  import format from '../../format.js'
  import smallbutton from '../controls/button.vue'
  import formentrystacked from '../controls/entry-stacked.vue'
  import entrySelect from '../controls/entry-select'
  import lookupresult from '../controls/lookupresult.vue'
  import linkbutton from '../controls/linkbutton'
  import updateproduct from '../actions/updateproduct.vue'
  import imagealldoc from '../controls/ImageAll.vue'
  import pricelabels from '../actions/pricelabels.vue'
import barcodes from '../actions/barcodes.vue'
  import updateoptions from './updateoptions.vue'
  import updateprepareas from './updateprepareas.vue'
 import optiontypeadmin from '../controls/optiontypeadmin.vue'
 import typeadmin from '../controls/typeadmin.vue'
 import imageadmin from '../controls/imageadmin.vue'
 import updateproducttype from '../actions/updateproducttype.vue'
  export default {
      name:'productdmin',
      mixins:[datamethods, format],
      components:{
          smallbutton,
          formentrystacked,
          entrySelect,
          lookupresult,
          linkbutton,
          updateproduct,
            barcodes,
            imagealldoc,
            pricelabels,
            updateoptions,
            updateprepareas,
            typeadmin,
            optiontypeadmin,
            imageadmin,
            updateproducttype
      },
      computed:{
          ...mapFields([
    
              'pleaseWait',
              'pleaseWaitText',
              'lastRefreshDateTime',
              'imagepath',
              'locationList',
              'locationList_Inventory',
            'locationId',
            'productString',
            'showInactive',
            'lookupresults',
            'selectedResultID',
            'currentProduct',
            'barcodesURL',
            'pricelabelURL',
            'loggedInUser',
            'prepAreaList',
            'productOptionList',
            'useProductImageTypes',
            'productImageList'
          ]),
          itemviewclass(){

              return 'itemview'
          },
          showFA(){
                if(window.SHOW_FINANCIALAID==undefined){return false}
                else{return window.SHOW_FINANCIALAID}
            },
            showShowOnline(){
                if(window.SHOW_SHOWONLINE==undefined){return false}
                else{return window.SHOW_SHOWONLINE}
            },
            showEcomOnline(){
                return !!window.ECOM_SHOW_ONLINE
            },
            showEcomShipping(){
                return !!window.ECOM_SHIPPING
            },
            showEcomTypeAdmin(){
                return !!window.ECOM_TYPE_ADMIN
            },
            showEcomLineAdmin(){
                return !!window.ECOM_LINE_ADMIN
            },
            showIsFireable(){
                return false
                 if(window.SHOW_ISFIREABLE==undefined){return false}
                else{return window.SHOW_ISFIREABLE}
            },
            showProductImage(){
                if(window.SHOW_PRODUCT_IMAGE==undefined){return false}
                else{return window.SHOW_PRODUCT_IMAGE}
            },
            getProductImage(){
                // Primary product image via Cloudflare (bullet-proofed): resolves the product-id
                // convention even when ImageFilename is a raw/POS name. Replaces the legacy
                // personimage/ path which 404s for product images in both tenants.
                if(!this.currentProduct || !this.currentProduct.id){return null}
                return this.cfImageUrl(this.currentProduct.id, this.currentProduct.imageFilename, 'public') || null
                },
            FACodeText(){
                if(window.FINANCIAL_AID_CODE_TEXT==undefined){return 'FA Code'}
                else{return window.FINANCIAL_AID_CODE_TEXT}
                
            },
            showProductPrepAreas(){
                if(window.SHOW_PRODUCT_PREPAREAS==undefined){return false}
                else{return window.SHOW_PRODUCT_PREPAREAS}
            },
            showProductOptions(){
                if(window.SHOW_PRODUCT_OPTIONS==undefined){return false}
                else{return window.SHOW_PRODUCT_OPTIONS}
            },
            // POS barcode/price-label reports — off for ecommerce admin unless explicitly enabled
            showProductReports(){
                return window.SHOW_PRODUCT_REPORTS===true
            },
            // Product image admin — gated until the X-API-Key image routes are wired (phase 1b)
            showImageAdmin(){
                return window.ECOM_IMAGE_ADMIN===true
            },


      },
      mounted(){
          // Legacy POS image endpoints (documentimagepath / useproductimagetypes) are not
          // called: documentimagepath has no tenant-path route and useproductimagetypes has
          // no server route at all, so both 404 on every tenant. They are vestigial with the
          // CF image manager (imagepath / useProductImageTypes keep their defaults), so the
          // calls are removed to eliminate the 404 console noise.
          if(this.showProductPrepAreas){this.getPrepAreas()}
          if(this.showProductOptions){this.getProductOptions()}

          if(this.locationId<=0){ this.locationId = this.loggedInUser.LocationId}
          if(this.locationList_Inventory.length==1){this.locationId=this.locationList_Inventory[0].id}
          if(this.selectedResultID>0){this.Refresh()}
          //this.GetLocations()
      },
      data(){
          return{
            lookupPromptText:"Lookup",
            responseMessage:'',
            trueParam:true,
            falseParam:false,
            listenersConnected:true,
            glCode_Anthology_FA:null,
                glCode_Anthology_Cash:null,
            productTypeEcomList:[],
            productLineEcomList:[],
            typeOnlineExpanded:false,
            lineOnlineExpanded:false,
            ecomImages:[],
            ecomFile:null,
            ecomUploadPrimary:false,
            ecomImageMsg:'',

          }
      },
      methods:{
          // ---- Ecommerce image resolution (Cloudflare Images) ----
          // Bullet-proof CF url builder. Always resolves to a valid Cloudflare image id or ''.
          // Rules (mirror the storefront's imageUtils so admin == storefront):
          //   1. clean CF name  product-<id>[-<ticks>][.ext]  -> <prefix>-<base>
          //   2. raw / legacy / POS name (e.g. "Plaid Pant Blue.jpg", spaces, no product- prefix)
          //      OR missing name -> fall back to the STABLE product-id convention
          //      <prefix>-product-<productId> (that id is what CF actually stores; verified live).
          // This stops the class of bug where a POS filename produced
          // imagedelivery.net/<hash>/Plaid Pant Blue/thumb (invalid id -> broken image).
          cfImageUrl(productId, fileName, variant){
              var hash = window.VUE_APP_CF_IMAGES_ACCOUNT_HASH
              var prefix = window.CF_IMAGE_PREFIX || ''
              if(!hash){return ''}
              variant = variant || 'thumb'
              var id = ''
              if(fileName){
                  var base = String(fileName).trim().replace(/\.(png|jpg|jpeg|gif|webp)$/i,'')
                  if(/^product-/.test(base)){ id = prefix ? (prefix + '-' + base) : base }
              }
              if(!id && productId){ id = (prefix ? prefix + '-' : '') + 'product-' + productId }
              if(!id){return ''}
              return 'https://imagedelivery.net/' + hash + '/' + encodeURIComponent(id) + '/' + variant
          },
          // Multi-image panel thumbnail. Takes the ProductImage row (has productId + fileName)
          // so a raw POS filename still falls back to the product-id CF image.
          ecomImageUrl(img){
              if(!img){return ''}
              // Back-compat: callers may pass a bare filename string.
              if(typeof img === 'string'){ return this.cfImageUrl(this.currentProduct && this.currentProduct.id, img, 'thumb') }
              return this.cfImageUrl(img.productId || (this.currentProduct && this.currentProduct.id), img.fileName, 'thumb')
          },
          async getEcomImages(){
              if(!this.currentProduct || !this.currentProduct.id){this.ecomImages=[];return}
              var response = await this.callAPI_Get('ecommerce/product/'+this.currentProduct.id+'/images')
              if(response.Successful){this.ecomImages = response.images || []}
              else{this.ecomImageMsg = response.Message}
          },
          onEcomFilePicked(e){
              var f = e.target.files[0]
              var v = this.validateImageFile(f)
              if(!v.ok){ this.ecomImageMsg = v.message; this.ecomFile = null; if(this.$refs.ecomImageFile){this.$refs.ecomImageFile.value=''}; return }
              this.ecomImageMsg = ''
              this.ecomFile = f
          },
          async uploadEcomImage(){
              if(!this.ecomFile){this.ecomImageMsg='Choose a file first';return}
              var fd = new FormData()
              fd.append('file', this.ecomFile)
              // A newly uploaded image becomes the primary (storefront) image by default so a
              // "replace image" upload actually takes effect. Use "Set as Primary" on the card
              // to re-point to an older gallery image.
              fd.append('setAsPrimary', 'true')
              this.$store.dispatch('beforeAPI')
              var response = await this.callAPI_Upload('ecommerce/product/'+this.currentProduct.id+'/images', fd)
              this.pleaseWait=false
              if(response.Successful){
                  this.ecomFile=null
                  if(this.$refs.ecomImageFile){this.$refs.ecomImageFile.value=''}
                  this.ecomImageMsg='Uploaded'
                  this.getItem(this.currentProduct.id)
              }else{this.ecomImageMsg = response.Message || 'Upload failed'}
          },
          async setEcomPrimary(imageId){
              this.$store.dispatch('beforeAPI')
              var response = await this.callAPI_Put('ecommerce/productimage/'+imageId+'/primary', {})
              this.pleaseWait=false
              if(response.Successful){this.ecomImageMsg='';this.getItem(this.currentProduct.id)}
              else{this.ecomImageMsg = response.Message}
          },
          async deleteEcomImage(imageId){
              if(!confirm('Delete this image?')){return}
              this.$store.dispatch('beforeAPI')
              var response = await this.callAPI_Delete('ecommerce/productimage/'+imageId)
              this.pleaseWait=false
              if(response.Successful){this.getEcomImages()}
              else{this.ecomImageMsg = response.Message}
          },
          toggleTypeOnline(){
              this.typeOnlineExpanded = !this.typeOnlineExpanded
              if(this.typeOnlineExpanded && this.productTypeEcomList.length===0){this.loadProductTypeEcom()}
          },
          toggleLineOnline(){
              this.lineOnlineExpanded = !this.lineOnlineExpanded
              if(this.lineOnlineExpanded && this.productLineEcomList.length===0){this.loadProductLineEcom()}
          },
          async loadProductTypeEcom(){
              this.$store.dispatch('beforeAPI')
              let req = {locationId:this.locationId}
              var response = await this.callAPI(req,'ecommerce/admin/producttypeecommerce')
              if(response.Successful){
                  this.productTypeEcomList = response.productTypeList
              }else{
                  this.responseMessage = response.Message
              }
              this.pleaseWait=false
          },
          async loadProductLineEcom(){
              this.$store.dispatch('beforeAPI')
              var response = await this.callAPI(null,'ecommerce/admin/productlineecommerce')
              if(response.Successful){
                  this.productLineEcomList = response.ProductLineList
              }else{
                  this.responseMessage = response.Message
              }
              this.pleaseWait=false
          },
          async saveProductLineEcom(pl){
              this.$store.dispatch('beforeAPI')
              var response = await this.callAPI(pl,'ecommerce/admin/updateproductlineecommerce')
              if(!response.Successful){
                  this.responseMessage = response.Message
              }
              this.pleaseWait=false
          },
        async getPrepAreas(){
            console.log('getprepareas')
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'prepareas')

            if(response.Successful){
                this.prepAreaList=response.ProductPrepAreaList
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
       
        },
        async getProductOptions(){
            console.log('getProductOption')

        

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'productoptions_admin')

            if(response.Successful){
                this.productOptionList=response.productOptionList
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
       
        },
        async getProductImages(){
            console.log('getimages')
             let req = {
                product:{id:this.selectedResultID},
            }
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'productImages')

            if(response.Successful){
                this.productImageList=response.ProductImageList
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        async savePrepArea(thistype){
        
            let req = {
                productPrepArea:thistype,
            }

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updatepreparea')
            if(response.Successful){
                this.getPrepAreas() //refresh      
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        async saveProductOption(thistype){
        
            let req = {
                productOption:thistype,
            }

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateproductoption')
            if(response.Successful){
                this.getProductOptions() //refresh      
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        async saveProductImage(thistype){
        
            let req = {
                productImage:thistype,
            }

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateproductimage')
            if(response.Successful){
                this.getProductImages() //refresh      
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        printbarcodes(url){
            this.barcodesURL = url
        }, 
        printpricelabels(url){
            this.pricelabelURL = url
        }, 
        toCurrency(value){
            return "$" + Number(value).toFixed(2);
        },
        isVisible(field){
            switch (field) {
                    case "IsFinancialAid":
                        return this.showFA
                        break;
                    case "ShowOnline":
                        return this.showShowOnline
                        break;
                    case "IsFireable":
                        return this.showIsFireable
                        break;
                    default:
                        return true
                        break;
                }
        },
          buildResultName(result){
              var name = result.name
              /* if (!result.IsActive){
                  name = name + ' INACTIVE'
              } */
              return name
          },
          
          async getimagepath(){
  
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(null,'documentimagepath')
              //handle response
              if(response.Successful){
                   this.imagepath= response.StringResponse
              }else{
                  this.responseMessage = response.Message
              }
              this.pleaseWait=false;  
          },
          select(result){
              this.selectedResultID=result.id
              this.getItem(result.id)
          },
          async RefreshNew(id){
            console.log('refresh ' + id)
              if(id==undefined){id=this.currentProduct.id}
              await this.lookup();
              this.selectedResultID=id
              await this.getItem(id)

              if(this.showProductOptions){
                this.$refs.updateoptions.Show()
              }
              
              if(this.showProductPrepAreas){
                console.log('auto pop prep')
                this.$refs.updateprepareas.Show()
                
              }
              
          },
          async Refresh(id){
              console.log('refresh ' + id)
              if(id==undefined){id=this.currentProduct ? this.currentProduct.id : this.selectedResultID}
              await this.lookup();
              this.selectedResultID=id
              if(id){await this.getItem(id)}
          },
          RefreshCurrent(){
              this.Refresh(this.currentProduct.id)
          },
          
          async lookup(){
            var scrollspot
            const div = this.$refs.lookupresultsdiv
            if(div!=undefined){
                scrollspot= div.scrollTop
            }


            this.responseMessage=null
            //if(this.productString==null){return}
            //if(this.productString==''){return}
            //console.log('lookup')
            this.lookupresults=[]
            let req = {
                locationId:this.locationId,
                lookupString:this.productString,
                includeInactive:this.showInactive
            }
                //call api
                this.$store.dispatch('beforeAPI');
                var response = await this.callAPI(req,'ecommerce/admin/productlookup')
                //handle response
            
                if(response.Successful){
                    this.lookupresults=response.productList
                    this.$nextTick(() => {
                        // guard: the results div is not rendered when there are no results
                        if(this.$refs.lookupresultsdiv){
                            this.$refs.lookupresultsdiv.scrollTop=scrollspot
                        }
                    })
                    if(this.lookupresults.length==0){
                        this.responseMessage="Product name/code not found at this location"
                    }
                }else{
                this.responseMessage = response.Message
                }
                this.pleaseWait=false;   
             
          },
          
          async getItem(id){
             console.log('get product ' + id)
     
              let req = {
                  productId:id,
                  locationId:this.locationId,
                  getOnHandQuantity:true,
                  getLocations:true
              }
              this.$store.dispatch('beforeAPI');
              var response = await this.callAPI(req,'ecommerce/admin/productlookup')
              //handle response
              if(response.Successful){
                   this.currentProduct =response.productList[0];
                   //this.$store.dispatch('setCurrentDateTime_Wallet');
                 this.barcodesURL=null
                 this.pricelabelURL=null
                 if(this.currentProduct.glCode_Anthology!=null){
                    var splitcode=this.currentProduct.glCode_Anthology.split("|")

                 
                    if(splitcode.length==2){
                        this.glCode_Anthology_FA =splitcode[0]
                        this.glCode_Anthology_Cash=splitcode[1]
                    }
                    else{
                        this.glCode_Anthology_FA =null
                        this.glCode_Anthology_Cash=splitcode[0]
                    }
                 }
                 if(this.useProductImageTypes){this.getProductImages()}
                 if(this.showImageAdmin){this.ecomImageMsg='';this.getEcomImages()}
              }else{
                  this.responseMessage = response.Message
              }
              this.pleaseWait=false;
  
          },
          async GetLocations(){
            
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'ecommerce/admin/locations')

            if(response.Successful){
                this.locationList=response.locationList

            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
       
    },
    async GetProductImageSetting(){
        
        this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(null,'useproductimagetypes')

            if(response.Successful){
                this.useProductImageTypes=response.ResponseInteger==1
            
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
    },
    addfile(){
        this.$refs.imgdoc.openModal() 
    },
    saveimg_document(file,url,typeId){
                this.storeDocument("doc", file, file.name,typeId)
    },
    
    async storeDocument(filename,file, name,typeId){
        var pId=this.currentProduct.id
        var postParams = new FormData();

        postParams.append(filename,file,name);
        postParams.append('productId',pId);


        var response = await this.callAPI(postParams,'saveproductimage')
        //handle response
        if(response.Successful){
            this.RefreshCurrent() 
        }else{
            this.responseMessage = response.Message
        }
            
    },   
    getImageForShow(pimage){
                // Bullet-proofed via Cloudflare: a raw/POS fileName (or missing) falls back to the
                // product-id convention instead of the legacy personimage/ path (which 404s).
                if(!pimage){return null}
                return this.cfImageUrl(pimage.productId, pimage.fileName, 'thumb') || null
            },   
    }
  }
  </script>
  
  <style>
  .reportLink{
    margin-top:40px;
    margin-left:10px;
  }
  .innerbutton{
    height:40px;
    border-radius: 5px;
}
  .splitDiv{
    border-radius:5px;
    margin:20px 0px 0px 0px;
    padding:0px;
    display:grid;
    grid-template-columns:1fr 1fr;
    text-align: left;
}
  .lookupdetail{
       margin:0px;
      display:grid;
      grid-template-columns:1fr 4fr;
      grid-template-rows:auto;
      grid-template-areas:
      "lookup detail";
      height:70vh;
  }
  /* Left column scrolls so the collapsible Type/Line panels below the results are reachable. */
  .lookup{
      overflow-y:auto;
      overflow-x:hidden;
      padding-right:8px;
  }
  /* Detail column (pad10) also scrolls when a product's detail is tall. */
  .pad10{
      overflow-y:auto;
  }

  .tokenname{
    margin:0px 10px 0px 0px ;
  }
  .note{
    word-wrap:break-word;
  }
  .resultsdiv{
  
      height:350px;
      overflow-x:hidden;
      overflow-y:scroll;
  }
  .transdiv{
      height:250px;
      overflow-x:hidden;
      overflow-y:scroll;
  }
  .itemview{
      padding-left:20px;
      
  }

  .refresh{
      display:flex;
      flex-direction: column;
      text-align: right;
      margin-right:20px;
  }
  .margintop{
      margin-top:5px;
  }
  .lookupHeader{
    display:flex;
    padding:0px;
    flex-direction: row;
    margin:0px 0px 0px 0px ;
    justify-content:space-between;
    width:100%;
  }
  .clearlink{
      margin-top:5px;
  }

  .entry{
    width: 100%;
    display:flex;

    justify-content: space-between;
}
.entryLabel{
    margin:5px;
    font-size:medium;
    text-align: left;   
}
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
.entryCheckbox{
    margin-left:5px;
}
.entryText{
    margin:5px;
    width:95%;
    font-size:inherit;
    font:inherit;
}
.entrySelect{
    margin:0px 0px 10px 0px;
    width:100%;
    height:25px;
    font-size:inherit;
}
.entryTextDiv{
    display:flex;
    flex-direction: row;
    min-width: 250px;
}

.dataitem{
    display:grid;
    grid-template-columns: 140px auto;
    margin:0px;
    padding:0px;
}
.dataitemwithcheck{
    display:grid;
    grid-template-columns: 100px auto 25px 150px;
    margin:0px;
    padding:0px;
}
.dataitem p{
    margin:3px;
}
.dataitemwithcheck p{
    margin:3px;
}

hr{
    border:solid 1px lightgray;
    width:95%;  
    margin-top:20px;
    margin-bottom:20px;
}
.locationcheck{
    height:15px;
    margin-top:15px;
    margin-right:5px;
}
.locationdiv{
    display:grid;
    grid-template-columns: 1fr 15fr;
}
.productimage{
    margin-left:40px;
}
.imageadmindiv{
    margin-top:30px;
}
.tinyproductimage{
    width:30px;
    margin-left:5px;
}
.tinyprodimagediv{
    height:30px;
}
.ecomAdminScroll{
    max-height:260px;
    overflow-y:auto;
    margin-bottom:10px;
}
.ecomImageCard{
    border:1px solid #ccc;
    border-radius:5px;
    padding:6px;
    margin:6px;
    width:120px;
    text-align:center;
}
/* compact buttons so they fit inside the image card */
.imgcardbtn{
    width:104px !important;
    height:26px !important;
    margin:3px 0px !important;
    font-size:12px !important;
    border-radius:6px !important;
}
.imgcardbtn .buttontext{
    font-size:12px !important;
}
.ecomImageThumb{
    width:100px;
    height:100px;
    object-fit:cover;
    border-radius:4px;
    background:#f0f0f0;
}
.ecomImagePrimary{
    color:var(--success-color, #699864);
    font-weight:bold;
    font-size:small;
}
  </style>